import { setShowResultsButton } from "@modules/azm/filter-selection/set-show-results-button.ts"
import { advertCardsContainerElement, getShowResultsButton } from "../../global/dom.ts"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { getFilterApiResult } from "../api"

async function handleShowResultsButtonClick() {
    const advertsCardsContainerEl = advertCardsContainerElement()
    if (advertsCardsContainerEl && getFilterApiResult()?.content) {
        advertsCardsContainerEl.innerHTML = getFilterApiResult()?.content || ""
        afterFilterApiFetched(getFilterApiResult())
    }
}

getShowResultsButton()?.addEventListener("click", handleShowResultsButtonClick)
setShowResultsButton(SearchConfig.advertCount)
